import { AppStepSection, StepCategory } from '../../types/app_data';
import { carsSpecialNextStep } from '../common/addcars';
import type { Step } from '../types/step';

export const CarsStep: Step = {
  id: 'cars',
  pathname: '/cars',
  canShow: (appData) => {
    if (appData.stepSection === AppStepSection.Challenge) {
      return true;
    }

    /**
     * When 'appData.isBeyondDrivingAge' is true, the cars step will be shown in onboarding lite flow.
     * Onboarding lite flow has default dwep service, but its cars step is in onboarding section,
     * not like the other normal signup flow (in create account section).
     */
    if (appData.isOnboardingLite && !!appData.isBeyondDrivingAge) {
      return true;
    }

    if (!appData.selectedService?.insurance) {
      return false;
    }

    return !appData.isOnboardingLite || !!appData.isBeyondDrivingAge;
  },
  hasData: () => true,
  hasOwnData: () => true,
  specialNextStep: carsSpecialNextStep,
  category: () => StepCategory.Cars,
};
